/* Build Your Own Bundle. The page shows the maths; Shopify's automatic discounts apply
   the money. "Add Bundle To Bag" adds every selected product in ONE /cart/add.js request. */
(function(){
  var MM = window.MM = window.MM || {};
  var dataEl = document.querySelector('[data-byob-json]'), grid = document.querySelector('[data-pick-grid]');
  if(!dataEl || !grid) return;
  var D = JSON.parse(dataEl.textContent), T = D.t;
  var tiers = D.tiers.filter(function(t){ return t.min > 0 && t.pct > 0; }).sort(function(a, b){ return b.min - a.min; });
  var maxMin = tiers.length ? tiers[0].min : 1;
  var money = function(c){ return MM.money ? MM.money(c) : '$' + (c/100).toFixed(2); };
  var root = grid.closest('.shopify-section') || document;
  var q = function(sel){ return root.querySelector(sel); };
  var bundle = {};              /* variant id -> qty */
  var cards = [].slice.call(grid.querySelectorAll('.pick[data-id]'));
  function card(id){ return cards.filter(function(c){ return c.dataset.id === String(id); })[0]; }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function count(){ return Object.keys(bundle).reduce(function(s, k){ return s + bundle[k]; }, 0); }
  function subtotal(){ return Object.keys(bundle).reduce(function(s, k){ return s + (+card(k).dataset.price) * bundle[k]; }, 0); }
  function tier(){ var n = count(); return tiers.filter(function(t){ return n >= t.min; })[0] || { min:0, pct:0 }; }
  function nextTier(){ var n = count(); return tiers.slice().reverse().filter(function(t){ return n < t.min; })[0] || null; }

  var toastTimer;
  function toast(msg){ var t = q('[data-toast]'); if(!t || !msg) return; t.textContent = msg; t.classList.add('show'); clearTimeout(toastTimer); toastTimer = setTimeout(function(){ t.classList.remove('show'); }, 2200); }

  function render(){
    var n = count(), sub = subtotal(), t = tier(), save = Math.round(sub * t.pct / 100), tot = sub - save;
    /* product cards */
    cards.forEach(function(c){
      var k = c.dataset.id, qty = bundle[k] || 0, act = c.querySelector('[data-pick-action]');
      c.classList.toggle('in-bundle', qty > 0);
      c.querySelector('.pick-count').textContent = qty;
      if(c.hasAttribute('data-soldout')) return;
      act.innerHTML = qty
        ? '<span class="stepper"><button type="button" data-dec aria-label="Remove one">−</button><span class="n">' + qty + '</span><button type="button" data-inc aria-label="Add one">+</button></span>'
        : '<button type="button" class="add-btn" data-inc>' + esc(T.add) + '</button>';
    });
    /* summary */
    var list = q('[data-items]'); list.innerHTML = '';
    Object.keys(bundle).forEach(function(k){
      var c = card(k), img = c.querySelector('.pick-frame img'), price = +c.dataset.price;
      var li = document.createElement('li');
      li.innerHTML = '<span class="cart-thumb">' + (img ? '<img src="' + (img.currentSrc || img.src) + '" alt="">' : '') + '</span>' +
        '<span class="cart-info"><span class="n">' + esc(c.dataset.name) + '</span><span class="q">' + esc(T.qty.replace('[qty]', bundle[k]).replace('[price]', money(price))) + '</span></span>' +
        '<span class="cart-line-price display">' + money(price * bundle[k]) + '</span>' +
        '<button type="button" class="cart-remove" data-rm="' + k + '" aria-label="Remove">✕</button>';
      list.appendChild(li);
    });
    list.classList.toggle('scrolls', list.scrollHeight > list.clientHeight + 2);
    q('[data-empty]').hidden = n > 0;
    q('[data-totals]').hidden = n === 0;
    q('[data-sub]').textContent = money(sub);
    q('[data-grand]').textContent = money(tot);
    q('[data-save-row]').hidden = t.pct === 0;
    q('[data-save-label]').textContent = T.saveLabel.replace('[pct]', t.pct);
    q('[data-save-amt]').textContent = '−' + money(save);
    /* ladder + meter */
    root.querySelectorAll('[data-ladder] .tier-pill').forEach(function(p){ p.classList.toggle('hit', n >= +p.dataset.min && t.min === +p.dataset.min); });
    q('[data-meter-fill]').style.width = Math.min(100, n / maxMin * 100) + '%';
    var nx = nextTier(), msg = q('[data-meter-msg]');
    if(n === 0 && nx) msg.innerHTML = T.start.replace('[n]', nx.min).replace('[pct]', nx.pct);
    else if(nx){ var need = nx.min - n; msg.innerHTML = T.more.replace('[n]', need).replace('[items]', need === 1 ? T.item : T.items).replace('[pct]', nx.pct); }
    else msg.innerHTML = T.max.replace('[pct]', t.pct);
    /* shipping */
    var ship = q('[data-ship]');
    if(D.freeShip){
      ship.innerHTML = n === 0 ? T.shipIdle.replace('[amount]', D.freeShipText)
        : (tot >= D.freeShip ? T.shipDone : T.shipMore.replace('[amount]', money(D.freeShip - tot)));
    }
    var btn = q('[data-checkout]');
    btn.disabled = n === 0;
    btn.textContent = n ? T.button + ' — ' + money(tot) : T.button;
    /* phone bar */
    q('[data-bar-total]').textContent = money(tot);
    q('[data-bar-count]').textContent = n + ' ' + (n === 1 ? T.item : T.items);
    q('[data-bar-save]').textContent = t.pct ? T.saving.replace('[amount]', money(save)).replace('[pct]', t.pct) : T.noSave;
  }

  function add(id, quiet){ bundle[id] = (bundle[id] || 0) + 1; if(!quiet) toast(T.added.replace('[name]', card(id).dataset.name)); render(); }
  function remove(id){ if(!bundle[id]) return; if(--bundle[id] <= 0) delete bundle[id]; render(); }

  grid.addEventListener('click', function(e){
    var c = e.target.closest('.pick'); if(!c) return;
    if(e.target.closest('[data-inc]')) add(c.dataset.id);
    else if(e.target.closest('[data-dec]')) remove(c.dataset.id);
  });
  q('[data-items]').addEventListener('click', function(e){ var rm = e.target.closest('[data-rm]'); if(rm){ delete bundle[rm.dataset.rm]; render(); } });
  q('[data-clear]').addEventListener('click', function(){ bundle = {}; render(); });

  root.querySelectorAll('.filter-chip').forEach(function(chip){
    chip.addEventListener('click', function(){
      root.querySelectorAll('.filter-chip').forEach(function(x){ x.classList.remove('on'); }); chip.classList.add('on');
      var f = chip.dataset.filter;
      cards.forEach(function(c){ c.hidden = !(f === 'all' || c.dataset.cat === f); });
    });
  });
  root.querySelectorAll('.preset-card').forEach(function(p){
    p.addEventListener('click', function(){
      bundle = {};
      cards.forEach(function(c){ if(!c.hasAttribute('data-soldout') && (' ' + c.dataset.presets + ' ').indexOf(' ' + p.dataset.preset + ' ') > -1) add(c.dataset.id, true); });
      render(); toast(T.preset);
      var b = document.getElementById('build'); if(b) b.scrollIntoView({ behavior: 'smooth' });
    });
  });

  /* one request for the whole bundle */
  q('[data-checkout]').addEventListener('click', function(){
    var items = Object.keys(bundle).map(function(k){ return { id: +k, quantity: bundle[k] }; });
    if(!items.length || !MM.addToBag) return;
    var btn = this; btn.disabled = true;
    MM.addToBag(items).then(function(){ toast(T.bagged.replace('[n]', count())); bundle = {}; document.body.classList.remove('drawer-open'); render(); })
      .catch(function(){ btn.disabled = false; });
  });

  /* phone drawer */
  var open = function(){ document.body.classList.add('drawer-open'); }, close = function(){ document.body.classList.remove('drawer-open'); };
  q('[data-bar-open]').addEventListener('click', open);
  q('[data-scrim]').addEventListener('click', close);
  q('[data-drawer-close]').addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });

  /* FAQ accordion (bundle questions) */
  document.querySelectorAll('.byob-faq .faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.parentElement, isOpen = item.classList.contains('open');
      document.querySelectorAll('.byob-faq .faq-item').forEach(function(i){ i.classList.remove('open'); i.querySelector('.faq-a').style.maxHeight = null; });
      if(!isOpen){ item.classList.add('open'); var a = item.querySelector('.faq-a'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });

  /* floating pearls */
  var layer = document.getElementById('pearlLayer');
  if(layer){
    var colors = ['', 'blue', 'pink'];
    for(var i = 0; i < 14; i++){
      var p = document.createElement('div'), size = 8 + Math.random() * 18;
      p.className = 'pearl ' + colors[Math.floor(Math.random() * 3)];
      p.style.width = size + 'px'; p.style.height = size + 'px'; p.style.left = (Math.random() * 100) + '%';
      p.style.animationDuration = (9 + Math.random() * 10) + 's'; p.style.animationDelay = (Math.random() * 10) + 's';
      layer.appendChild(p);
    }
  }
  render();
})();
